<template>
  <v-row dense v-if="totalAmountWithDiscount">
    <v-col cols="12" class="text-left">
      <v-card elevation="2" class="pa-0">
        <v-card-title class="pb-2">
          <v-icon left color="green">mdi-calculator</v-icon>
          <span class="text-h6 font-weight-bold green--text text--darken-2">
            Resumen del Pedido
          </span>
        </v-card-title>

        <v-card-text class="pa-0">
          <v-list dense class="cart-total-list pa-0">

            <v-list-item class="cart-item">
              <v-list-item-avatar size="32" class="item-avatar">
                <v-icon color="primary">shopping_cart</v-icon>
              </v-list-item-avatar>
              <v-list-item-content class="item-content">
                <v-list-item-title class="item-label">
                  {{ $t('delivery.cart.products') }}:
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="item-value">
                <span class="amount-text">{{ currencyFormat(itemsAmount) }}</span>
              </v-list-item-action>
            </v-list-item>

            <v-list-item v-if="deliveryCost" class="cart-item">
              <v-list-item-avatar size="32" class="item-avatar">
                <v-icon color="orange">delivery_dining</v-icon>
              </v-list-item-avatar>
              <v-list-item-content class="item-content">
                <v-list-item-title class="item-label">
                  {{ $t('delivery.cart.deliveryCost') }}:
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="item-value">
                <span v-if="deliveryFree" class="delivery-free">
                  <span class="text-decoration-line-through grey--text mr-2">
                    {{ currencyFormat(deliveryCost) }}
                  </span>
                  <v-chip small color="success" text-color="white">
                    {{ $t('delivery.cart.free') || 'GRATIS' }}
                  </v-chip>
                </span>
                <span v-else class="amount-text">{{ currencyFormat(deliveryCost) }}</span>
              </v-list-item-action>
            </v-list-item>

            <v-list-item v-if="totalDiscount" class="cart-item discount-item">
              <v-list-item-avatar size="32" class="item-avatar">
                <v-icon color="success">local_offer</v-icon>
              </v-list-item-avatar>
              <v-list-item-content class="item-content">
                <v-list-item-title class="item-label">
                  {{ $t('delivery.cart.discount') }}:
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="item-value">
                <div class="discount-value">

                  <span class="discount-amount">-{{ currencyFormat(totalDiscount) }}</span>
                  <v-chip v-if="discountRate > 0"
                          small
                          color="success"
                          text-color="white"
                          class="mr-2">
                    -{{discountRate}}%
                  </v-chip>
                </div>
              </v-list-item-action>
            </v-list-item>


            <v-list-item class="cart-item total-item">
              <v-list-item-avatar size="32" class="item-avatar">
                <v-icon color="blue darken-2" size="28" >payments</v-icon>
              </v-list-item-avatar>
              <v-list-item-content class="item-content">
                <v-list-item-title class="total-label blue--text text--darken-2">
                  {{ $t('delivery.cart.total') }}:
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="item-value">
                <span class="total-amount blue--text text--darken-2">{{ currencyFormat(totalAmountWithDiscount) }}</span>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import CurrencyMixin from "@/modules/delivery/mixins/CurrencyMixin";

export default {
  name: "CartTotal",
  mixins:[CurrencyMixin],
  props: {
    itemsAmount: {type: Number, default: 0},
    deliveryCost: {type: Number, default: null},
    deliveryFree: {type: Boolean, default: false},
    discountRate: {type: Number, default: null},
    totalDiscount: {type: Number, default: null},
    totalAmount: {type: Number, default: 0},
    totalAmountWithDiscount: {type: Number, default: 0},
  }
}
</script>

<style scoped>
.cart-total-card {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.cart-total-header {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  border-radius: 0 !important;
}

.cart-total-list {
  background: #fafafa;
}

.cart-item {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  transition: background-color 0.2s ease;
}

.cart-item:hover {
  background-color: #f5f5f5;
}

.cart-item:last-child {
  border-bottom: none;
}

.item-avatar {
  margin-right: 12px;
  background-color: #f8f9fa;
  border-radius: 50%;
}

.item-content {
  flex-grow: 1;
}



.item-value {
  margin-left: auto;
  min-width: auto;
}

.amount-text {
  font-size: 14px;
  font-weight: 600;
}

.delivery-free {
  display: flex;
  align-items: center;
}

.discount-item {
  background-color: #e8f5e8;
}

.discount-value {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
}

.discount-amount {
  font-size: 14px;
  font-weight: 700;
  color: #2e7d32;
}

.total-item {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 16px;
}


.total-amount {
  font-size: 16px;
  font-weight: 800;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .cart-item {
    padding: 10px 12px;
  }

  .item-label {
    font-size: 13px;
  }

  .amount-text {
    font-size: 13px;
  }

  .total-amount {
    font-size: 16px;
  }
}

/* Animation for discount chip */
.v-chip {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
</style>
